import { IErrorResult, IResult } from '../../models/result-models';
import {
    CLEAR_SAVED_CART,
    LOAD_SAVED_CART_SUCCESS,
    LOAD_SAVED_CART_ERROR,
    MOVE_PRIMARY_TO_SAVED_SUCCESS,
    MOVE_PRIMARY_TO_SAVED_ERROR,
    MOVE_SAVED_TO_PRIMARY_SUCCESS,
    MOVE_SAVED_TO_PRIMARY_ERROR,
} from './cart-actions';
import { ICartItemInfo } from '../../models/pro-sites';

interface IClearSavedCartAction {
    type: 'CLEAR_SAVED_CART';
}

interface ILoadSavedCartSuccessAction {
    type: 'LOAD_SAVED_CART_SUCCESS';
    payload: IResult<ICartItemInfo[]>;
}

interface ILoadSavedCartErrorAction {
    type: 'LOAD_SAVED_CART_ERROR';
    payload: IErrorResult;
}

interface IMovePrimaryToSavedSuccessAction {
    type: 'MOVE_PRIMARY_TO_SAVED_SUCCESS';
    payload: IResult<ICartItemInfo[]>;
}

interface IMovePrimaryToSavedErrorAction {
    type: 'MOVE_PRIMARY_TO_SAVED_ERROR';
    payload: IErrorResult;
}

interface IMoveSavedToPrimarySuccessAction {
    type: 'MOVE_SAVED_TO_PRIMARY_SUCCESS';
    payload: IResult<ICartItemInfo[]>;
}

interface IMoveSavedToPrimaryErrorAction {
    type: 'MOVE_SAVED_TO_PRIMARY_ERROR';
    payload: IErrorResult;
}

type KnownAction =
    | IClearSavedCartAction
    | ILoadSavedCartSuccessAction
    | ILoadSavedCartErrorAction
    | IMovePrimaryToSavedSuccessAction
    | IMovePrimaryToSavedErrorAction
    | IMoveSavedToPrimarySuccessAction
    | IMoveSavedToPrimaryErrorAction;

export const savedCartReducer = (
    state: IResult<ICartItemInfo[]> | null | undefined = null,
    action: KnownAction
) => {
    switch (action.type) {
        case CLEAR_SAVED_CART:
            return {
                ...state,
                ok: true,
                data: null,
            };
        case LOAD_SAVED_CART_SUCCESS:
        case MOVE_PRIMARY_TO_SAVED_SUCCESS:
        case MOVE_SAVED_TO_PRIMARY_SUCCESS:
            return action.payload;
        case LOAD_SAVED_CART_ERROR:
        case MOVE_PRIMARY_TO_SAVED_ERROR:
        case MOVE_SAVED_TO_PRIMARY_ERROR:
            return {
                ok: false,
                data: state!.data,
                errors: action.payload.modelErrors,
                message: action.payload.errorMessage,
            };
        default:
            return state;
    }
};
